import React from 'react';
import styled from '@emotion/styled';
import Close from 'foundation/icons/close';

interface ModalProps {
    onClose: () => void;
    children: React.ReactNode;
    title?: string;
    minHeight?: number | 'auto';
}

export default function Modal({onClose, children, title, minHeight = 202}: ModalProps) {
    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={e => e.stopPropagation()} minHeight={minHeight}>
                <button className='close-button' onClick={onClose}>
                    <Close />
                </button>
                {title && <ModalTitle>{title}</ModalTitle>}
                {children}
            </ModalContent>
        </ModalOverlay>
    );
}

const ModalOverlay = styled.div`
    max-width: var(--max-width);
    margin: 0 auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
`;

const ModalContent = styled.div<{minHeight: number | 'auto'}>`
    padding: 24px;
    position: relative;
    width: 350px;
    max-width: 90%;
    min-height: ${({minHeight}) => (minHeight === 'auto' ? 'auto' : `${minHeight}px`)};
    border-radius: 16px;
    background-color: white;

    .close-button {
        position: absolute;
        top: 24px;
        right: 18px;
    }
`;

const ModalTitle = styled.h2`
    padding-top: 24px;
    padding-bottom: 12px;
    color: #222;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
    letter-spacing: -0.36px;
`;
